import React from 'react';
import { Result, Button } from '@nackle/origami';
import { routeHistory } from '@nackle/biw-web-router';
import { getString } from '@nackle/intl-tools';

const NotFound = () => {
    const goHome = () => {
        routeHistory.push( '/home/' );
    };
    return (
        <Result status={ '404' } type={ 'image' }
            title={ getString( 'umbrella.notFound.uhoh' ) }
            subTitle={ getString( 'umbrella.notFound.sorry' ) }
            extra={ <Button shape={ 'round' } type="primary" onClick={ () => goHome() }>{ getString( 'umbrella.notFound.home' ) }</Button> }
        />
    );
};

export default NotFound;
